<template>
  <ul class="list">
    <slot />
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'List',
})
</script>

<style lang="scss" scoped>
@import '@/uiKit/assets/spacings.scss';

.list {
  @include col;
  overflow: auto;
  width: 100%;
  margin: 0;
  padding: 0;
  gap: $spacing-2;
}
</style>
